import { DialogProps } from "@b2bportal/core-ui";
import { useState } from "react";

export const useDialog = (): DialogProps => {
  const [open, setOpen] = useState(false);

  return {
    open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false),
  };
};
